import SubmissionError from "../../../../error/SubmissionError";
import fetch from "../../../../utils/fetch";
import * as types from "./mutation_types";
import { Feed } from "../../../../interfaces/feed"

export const create = ({ commit, state, rootState }, values:Feed) => {
  commit(types.FEED_CREATE_SET_ERROR, "");
  commit(types.FEED_CREATE_TOGGLE_LOADING);

  // START:CUSTOM - generated
  let token = rootState.auth.token;
  // END:CUSTOM - generated

  return fetch("feeds", { method: "POST", body: JSON.stringify(values) }, token)
    .then((response) => {
      commit(types.FEED_CREATE_TOGGLE_LOADING);

      return response.json();
    })
    .then((data) => {
      commit(types.FEED_CREATE_SET_CREATED, data);
    })
    .catch((e) => {
      commit(types.FEED_CREATE_TOGGLE_LOADING);

      if (e instanceof SubmissionError) {
        commit(types.FEED_CREATE_SET_VIOLATIONS, e.errors);
        // eslint-disable-next-line
        commit(types.FEED_CREATE_SET_ERROR, e.errors._error);

        return;
      }

      commit(types.FEED_CREATE_SET_ERROR, e.message);
    });
};

export const reset = ({ commit }) => {
  commit(types.FEED_CREATE_RESET);
};
